import classNames from 'classnames';
import { CSSProperties, FC, ReactNode, useId } from 'react';
import { Collapse } from '../../atoms/collapse';

const Accordion: FC<IAccordionProps> = ({
  children,
  isOpen,
  toggle,
  onMouseEnter,
  onMouseLeave,
  title,
  className,
  style,
  ...props
}) => {
  const panelId = useId();

  return (
    // Hover handlers are visual-only (FAQ border); expand/collapse is the title button.
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    <div
      className={classNames('accordion', className)}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={style}
      {...props}
    >
      <button
        aria-controls={panelId}
        aria-expanded={isOpen}
        className="accordion__title"
        onClick={toggle}
        type="button"
      >
        {title}
      </button>
      <Collapse className={undefined} isOpen={isOpen}>
        <div className="accordion__body" id={panelId}>
          {children}
        </div>
      </Collapse>
    </div>
  );
};

interface IAccordionProps {
  children: ReactNode;
  className?: string;
  isOpen: boolean;
  title: string | ReactNode;
  style?: CSSProperties;
  // eslint-disable-next-line no-unused-vars
  toggle: (e: any) => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

export default Accordion;
